//import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {postApi, putApi, consoleLog} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

//import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
//import Modal from 'react-bootstrap/Modal';

//import './css/index.css';
//import './css/header.css';

export default class PortalAdminInvitesComponent extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				id: this.props.service,
			},
			invites: [],
		};
		this.getInvites = this.getInvites.bind(this);
		this.inviteStatus = this.inviteStatus.bind(this);
  };

  async componentDidMount() {
		/*const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/admin/admin`, params);
		consoleLog(x.data);

		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		x.data.overview.shorttitle = x.data.description.title;
		this.setState({service, overview: x.data.overview});
		setTitle('Invites', x.data.servicename);*/
		//this.setState({status: true, services: x.data.Services});
		

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

		this.getInvites();
	}

	componentWillUnmount() {
	}

	async getInvites() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi('/v3/portal/invites', params);
		consoleLog(x.data);
		if( x.status === 200 ) {
			this.setState({invites: []},()=>{
				this.setState({invites: x.data});
			});
		}
	}


	async inviteStatus(id, status) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		params.append('status', status);
		const x = await putApi('/v3/portal/invites', params);
		
		if( x.status === 200 ) {
			this.getInvites();
		}
	}

	render() {
		//const user = this.context;

		const invites = this.state.invites.map((e,i) => {
			return (
				<Col md={6} key={i}>
          <div class="card custom-card">
						<div class="card-header">
							<div class="d-flex align-items-center w-100">
								<div class="me-2">
									<span class="avatar avatar-rounded">
										<img src={`https://cloud.ultrastream.io/images/${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="img" />
									</span>
								</div>
								<div class="">
									<div class="fs-15 fw-semibold">{e.title}</div>
									<p class="mb-0 text-muted fs-11">{moment(new Date(e.mtime)).format("L  LT")}</p>
								</div>
								{/*<div class="dropdown ms-auto">
									{e.status === 0 && <Button size="sm" variant="info" disabled={true}>Waiting Approval</Button>}
									{e.status === 1 && <Button size="sm" variant="success" disabled={true}>Invite Approved</Button>}
									{e.status === 2 && <Button size="sm" variant="danger" disabled={true}>Invite Declined</Button>}
								</div>*/}
                <div className="dropdown ms-auto">
								{e.status === 0 &&
									<ButtonGroup size="sm">
										<Button variant="success" onClick={()=>this.inviteStatus(e.id, 1)}><FontAwesomeIcon icon="check" />&nbsp;Accept</Button>
										<Button variant="danger" onClick={()=>this.inviteStatus(e.id, 2)}><FontAwesomeIcon icon="xmark" />&nbsp;Decline</Button>
									</ButtonGroup>
								}

								{e.status === 1 &&
									<ButtonGroup size="sm">
										<Button variant="success" disabled={true}><FontAwesomeIcon icon="check"/>&nbsp;Accepted</Button>
										
									</ButtonGroup>
								}

								{e.status === 2 &&
									<ButtonGroup size="sm">
										<Button variant="danger" disabled={true}><FontAwesomeIcon icon="xmark"/>&nbsp;Declined</Button>
									</ButtonGroup>
								}
								
							</div>
							</div>
						</div>
						<div class="card-body">
							<ol class="list-group list-group-numbered">
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Fullname:</div>
										{e.fullname?e.fullname:'Name not provided'}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Facebook Profile Page:</div>
										{e.facebook?e.facebook:'Facobook page not provided'}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">DJ'ing Experience:</div>
										{e.djing}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Broadcasting Experience:</div>
										{e.broadcasting}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between align-items-start">
									<div class="ms-2 me-auto text-muted">
										<div class="fw-semibold fs-14 text-default">Link to previous set:</div>
										{e.previous?e.previous:'Link to previous set not provided'}
									</div>
								</li>
							</ol>
						</div>
					</div>
				</Col>
			)
		});

		return (
			<>
				{invites}
			</>
		);
	}
}

